import { YearSelectComponent } from '@components/year-select/year-select.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [YearSelectComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [YearSelectComponent]
})
export class YearSelectModule { }
